

export const Routes = {
    // pages
    Presentation: { path: "/presentation" },
    DashboardOverview: { path: "/dashboard" },
    Transactions: { path: "/gestion-des-services" },
    Settings: { path: "/profil" },
    Agent:{path:"/agent"},
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/service" },
    Villes: { path: "/cities" },
    Arrondissement: { path: "/arrondissement" },
    Categories: { path: "/categories" },
    AccessConfig: { path: "/gestion-de-l-acces" },
    Demandes: { path: "/demandes-ajouts" },
    DemandesProcedure: { path: "/demandes-procedures" },
    DemandesEtapes: { path: "/demandes-etapes" },
    DemandesDevis: { path: "/demandes-devis" },
    // BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    Signin: { path: "/" },
    Etapeprocedure: { path: "/gestion-d-etapes-des-procedures" },
    Signup: { path: "sign-up" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/page-introuvable" },
    ServerError: { path: "/examples/500" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" }
};
